<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M4.66406 9.6665L7.9974 12.9998L11.3307 9.6665M11.3307 6.33333L7.9974 3L4.66406 6.33333"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
